<template>
  <div class="wrapper">
    <div class="top-bar">
      <div class="top-bar-left" @click="backToResearch()">
         <i class="el-icon-back"></i>我的笔记</div>
    </div>
    <div class="content">
      <div class="mdc">
        <el-form label-width="60px">
          <el-col :span="4">
            <el-form-item label="年级">
              <el-select
                v-model="params.grade"
                placeholder="请选择年级"
                @change="selectGrade"
                clearable
              >
                <el-option
                  v-for="item in gradeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="学科" prop="region">
              <el-select
                v-model="params.subject"
                placeholder="请选择学科"
                @change="selectSubject"
                clearable
              >
                <el-option
                  v-for="item in subjectList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6" :offset="10">
            <div class="key-container">
              <div class="note-count">{{ "共" + noteCount + "条" }}</div>
              <div>
                <el-input
                  placeholder="请输入关键字"
                  suffix-icon="el-icon-search"
                  v-model="params.name"
                  @change="keyChange"
                ></el-input>
              </div>
            </div>
          </el-col>
        </el-form>
        <div class="note-container">
          <div v-if="noteList.length > 0 && isLoad" >
            <div
              v-for="(item, index) in noteList"
              :key="item.id"
              class="note-item"
              :span="4"
            >
              <div class="note-item-content">
                <div class="name">{{ item.name }}</div>
                <div class="name">主讲：{{ item.lecturer_name }}</div>
                <div>学校：{{ item.from }}</div>
                <div>
                  年级：{{ item.gradeName }} 丨 学科：{{ item.subjectName }}
                </div>
                <div>活动时间：{{ item.createtimeStr }}</div>
              </div>
              <div class="note-item-operate">
                <div class="del" @click="deleteItem(index)">
                  <i class="el-icon-delete"></i>
                </div>
                <div class="edit" @click="edit(index)">
                  <i class="el-icon-edit"></i>
                </div>
                <div class="view" @click="show(index)">
                  <i class="el-icon-view"></i>
                </div>
              </div>
            </div>
          </div>

          <el-empty v-if="noteList.length == 0 && isLoad" description="暂无数据"></el-empty>
        </div>
        <div style="text-align: right" v-if="noteCount > 0">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="params.page"
            :page-size="params.page_size"
            background
            layout="prev, pager, next"
            :total="noteCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="听课笔记"
      :visible.sync="showDetailDialog"
      width="50%"
      center
    >
      <div class="border-container">
        <div class="border-container-title">课程信息</div>
        <div class="border-container-content">
          <div class="name">{{ note.name }}</div>
          <div class="name">主讲：{{ note.lecturer_name }}</div>
          <div>学校：{{ note.from }}</div>
          <div>年级：{{ note.gradeName }} 丨 学科：{{ note.subjectName }}</div>
          <div>活动时间：{{ note.createtimeStr }}</div>
        </div>
      </div>
      <div class="border-container">
        <div class="border-container-title">教学内容</div>
        <div class="border-container-content">
          {{ note.content }}
        </div>
      </div>
      <div class="border-container">
        <div class="border-container-title">点评</div>
        <div class="border-container-content">
          {{ note.comment }}
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="听课笔记"
      :visible.sync="showEditDialog"
      width="50%"
      center
    >
      <div class="border-container">
        <div class="border-container-title">课程信息</div>
        <div class="border-container-content">
          <div class="name">{{ note.name }}</div>
          <div class="name">主讲：{{ note.lecturer_name }}</div>
          <div>学校：{{ note.from }}</div>
          <div>年级：{{ note.gradeName }} 丨 学科：{{ note.subjectName }}</div>
          <div>活动时间：{{ note.createtimeStr }}</div>
        </div>
      </div>
      <div class="border-container">
        <div class="border-container-title">教学内容</div>
        <div class="border-container-content">
          <el-input
            type="textarea"
            placeholder="请输入教学内容"
            v-model="note.content"
            maxlength="500"
            show-word-limit
            rows="6"
          >
          </el-input>
        </div>
      </div>
      <div class="border-container">
        <div class="border-container-title">点评</div>
        <div class="border-container-content">
          <el-input
            type="textarea"
            placeholder="请输入点评"
            v-model="note.comment"
            maxlength="500"
            show-word-limit
            rows="6"
          >
          </el-input>
        </div>
      </div>
      <div slot="title" class="dialog-title">
        听课笔记
        <div class="dialog-title-save">
          <el-button type="primary" size="small" @click="saveNote"
            >确 定</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      isLoad: false,
      userInfo: null,
      noteCount: 0,
      gradeList: [],
      allSubjectList: [],
      subjectList: [],
      keyStr: "",
      noteList: [],
      params: {
        page: 1,
        page_size: 20,
        name: "",
        order: "desc",
        grade: "",
        subject: "",
      },
      showDetailDialog: false,
      showEditDialog: false,
      note: {},
      timeOut: null
    };
  },
  //监听路由变化 控制首页背景图
  watch: {},
  created() {},

  beforeMount() {},
  mounted() {
    this.userInfo = JSON.parse(sessionStorage.userInfo);
    this.getGradeList();
  },
  methods: {
    //获取年级
    getGradeList() {
      this.axios.get("/teacher/subject/getgrads").then((res) => {
        if (res.data.code == 1) {
          this.gradeList = res.data.data;
          this.getSubjectList();
        }
      });
    },
    getSubjectList() {
      this.axios
        .get("/teacher/subject/getsubject", {
          params: { schoolcode: this.userInfo.school_code },
        })
        .then((res) => {
          this.allSubjectList = res.data.data;
          this.subjectList = res.data.data;
          this.getData();
        });
    },
    //选中年级
    selectGrade() {
      this.params.subject = "";
      if (this.params.grade) {
        let gradeId = parseInt(this.params.grade / 10) * 10;
        this.subjectList = this.allSubjectList.filter(
          (x) => x.grade_id == gradeId
        );
      } else {
        this.subjectList = this.allSubjectList;
      }

      this.params.page = 1;
      this.getData();
    },
    selectSubject() {
      this.params.page = 1;
      this.getData();
    },
    keyChange(){
        if (this.timeOut != null) {
            window.clearTimeout(this.timeOut);
            this.timeOut = null;
        }
        this.timeOut = window.setTimeout(this.loadData(), 300);
    },
    loadData(){
        this.params.page = 1;
        this.getData();
    },
    formatDate(date, fmt) {
      let ret;
      const opt = {
        "y+": date.getFullYear().toString(), // 年
        "M+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "m+": date.getMinutes().toString(), // 分
        "s+": date.getSeconds().toString(), // 秒
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
          );
        }
      }

      return fmt;
    },
    getData() {
      this.axios
        .post(`/teacher/research/getNoteList`, this.params)
        .then((res) => {
          var list = res.data.data.data;
          this.noteCount = res.data.data.count;
          list.forEach((x) => {
            x.gradeName = this.gradeList.find((y) => y.id == x.grade).name;
            x.subjectName = this.subjectList.find(
              (y) => y.code == x.subject_code
            ).name;
            x.createtimeStr = this.formatDate(
              new Date(x.createtime * 1000),
              "yyyy-MM-dd HH:mm"
            );
          });
          this.noteList = list;
          this.isLoad = true;
        });
    },
    handleCurrentChange(val) {
      this.params.page = val;
      this.getData();
    },
    deleteItem(index) {
      this.$confirm("确认删除笔记吗？")
        .then((_) => {
          this.deleteNote(index);
        })
        .catch((_) => {});
    },
    deleteNote(index) {
      this.axios.post(`/teacher/research/deleteNote`, {
          uuid: this.noteList[index].uuid
        })
        .then((res) => {
          this.$message({
            message: res.data.msg,
            type: "success",
            duration: 1500,
            showClose: true,
          });
        if(res.data.code == 1){
            this.getData();
          }
        });
    },
    backToResearch(){
        this.$router.push('/research');
    },
    edit(index) {
      this.note = this.noteList[index];
      this.showEditDialog = true;
    },
    show(index) {
      this.note = this.noteList[index];
      this.showDetailDialog = true;
    },
    saveNote() {
      this.axios
        .post(`/teacher/research/saveNote`, {
          uuid: this.note.uuid,
            teach_activity_uuid: this.note.teach_activity_uuid,
            content: this.note.content,
            comment: this.note.comment
        })
        .then((res) => {
          this.$message({
            message: res.data.msg,
            type: "success",
            duration: 1500,
            showClose: true,
          });
          if(res.data.code == 1){
            this.showEditDialog = false;
            this.getData();
          }
          
        });
    },
  },
};
</script>

<style scoped>
.wrapper {
  margin: 0px auto;
  height: calc(100vh - 142px);
  overflow: auto;
  width: 75vw;
  padding-top: 10px;
  position: relative;
}
.top-bar {
  padding: 8px 16px;
  height: 44px;
  overflow: hidden;
  position: relative;
  background-color: white;
    border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.top-bar-left {
  position: absolute;
  top: 8px;
  line-height: 44px;
  left: 16px;
  cursor: pointer;
}
.top-bar-right {
  position: absolute;
  top: 8px;
  right: 16px;
}


.content {
  height: calc(100vh - 212px);
  border: 2px solid #f6f6f6;
  overflow: auto;
  background-color: white;
}
.mdc {
  background-color: white;
  padding: 16px;
  height: calc(100vh - 248px);
  margin-top: 4px;
  display: flex;
  flex-direction: column;
}
.note-container {
   height: calc(100vh - 300px);
  overflow: auto;
}
.note-item {
  display: inline-block;
  width: 13.5vw;
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  position: relative;
  font-size: 12px;
  margin-bottom: 10px;
  margin-right: 1vw;
  overflow: hidden;
  line-height: 24px;
}

.note-container .note-item:nth-child(5n){
 margin-right: 0;
}

.note-item div {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.note-item .name {
  color: #303133;
  font-weight: bold;
  font-size: 14px;
}

.note-item-content {
  padding: 16px;
  flex: 1;
}
.note-item-operate {
  height: 32px;
  background: rgb(246, 246, 246);
  display: flex;
  flex-direction: row;
  align-items: center;
}
.key-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.note-count {
  font-size: 14px;
  margin-right: 8px;
}
.note-item-operate .del {
  flex: 1;
}

.note-item-operate i {
  padding: 8px 8px;
  color: black;
  font-size: 20px;
  cursor: pointer;
}
.note-item-operate i:hover {
  font-weight: bold;
}

.border-container {
  padding: 16px;
  border: 1px solid #e4e7ed;
  margin-bottom: 16px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px #ddd;
}

.border-container-title {
  color: #409eff;
}
.border-container-content {
  font-size: 12px;
}
.dialog-title {
  text-align: center;
  font-size: 16px;
  position: relative;
  height: 40px;
}

.dialog-title-save {
  position: absolute;
  top: -10px;
  right: 30px;
}
</style>
